import React, {FC} from 'react'

import cn from 'classnames/bind'

import s from './LayoutPayment.module.scss'
import LayoutDefault from '../LayoutDefault'

const cx = cn.bind(s)

interface ILayoutPaymentProps {
	className?: string
}

const LayoutPayment: FC<ILayoutPaymentProps> = ({className, children}) => {
	return (
		<LayoutDefault hasMenuStub={false} hasMenuLinks={false} className={cx('wrapper', className)}>
			{children}
		</LayoutDefault>
	)
}

LayoutPayment.displayName = 'LayoutPayment'

export default LayoutPayment
